// Sends a contact form submission to the PHP endpoint at public/api/contact.php
// (same pattern as the Centro Diagnostico Buenavista site). That file only
// runs once deployed, Vite's dev server does not execute PHP, so in local
// dev this will fail unless VITE_CONTACT_API points at a locally running
// PHP server, see the note at the top of contact.php.
const CONTACT_API = import.meta.env.VITE_CONTACT_API || '/api/contact.php';

export async function sendContactMessage(payload) {
  const res = await fetch(CONTACT_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // `website` is a honeypot field: always sent empty by real users (the
    // form's honeypot input is visually hidden but not removed from the
    // DOM), non-empty means a bot filled every field it could find.
    body: JSON.stringify({ website: '', ...payload }),
  });

  const data = await res.json().catch(() => null);
  if (!res.ok || !data?.ok) {
    throw new Error(data?.error || 'CONTACT_SEND_FAILED');
  }
}
